module.exports = __webpack_public_path__ + "media/evolve/assets/icons/atlas/survey-task-f15b8e40263ae72899a0a59e690f2c27.svg";